import * as React from "react";

export default function useFileBrowser(callback: (file: File) => void) {
  const input = React.useRef<HTMLInputElement>();

  React.useEffect(() => {
    const element = document.createElement("input");

    element.type = "file";
    // element.accept = "jpg";
    element.multiple = false;
    element.hidden = true;
    element.setAttribute("data-testid", "file-input");

    input.current = element;
    document.body.appendChild(element);

    return () => {
      document.body.removeChild(element);
    };
  }, []);

  return () => {
    if (input.current) {
      input.current.value = "";
      input.current.onchange = () => {
        if (input.current!.files && input.current!.files[0]) {
          callback(input.current!.files[0]);
        }

        input.current!.onchange = null;
      };
      input.current.click();
    }
  };
}
